import { Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { faBan, faDownload } from '@fortawesome/free-solid-svg-icons';
import { NbToastrService } from '@nebular/theme';
import { FilterSettingsModel, GridComponent, PageSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import * as moment from "moment-timezone";
import { finalize } from 'rxjs/operators';
import { ErrorService } from '../../../../@core/utils/error.service';
import { DownloadItems } from '../../models/download-items';
import { DownloadsService } from '../../services/downloads.service';
@Component({
  selector: 'downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {

  @ViewChild('grid') public grid: GridComponent;
  toolbar: ToolbarItems[] = ['Search'];
  public pageSettings: PageSettingsModel = {
    pageSize: 20,
    pageSizes: [50, 100, 200],
  };
  public filterSettings: FilterSettingsModel = {
    mode: "Immediate",
    type: "Excel",
  };
  private destroyRef = inject(DestroyRef);
  downloadItems: DownloadItems[] = [];
  testdownloadItemsData: any = [];
  isloading : boolean = false;
  public filterCount: number = 0;
  fadownload = faDownload;
  faBan = faBan;
  @ViewChild("dateTemplate") public dateTemplate: any;


  constructor(private downloadService: DownloadsService,
    private errorService: ErrorService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    this.loadDownloadItemsData();
  }
  loadDownloadItemsData(){
    this.isloading = true;
      
      this.downloadService.getDownloadItems()
      .pipe(takeUntilDestroyed(this.destroyRef), finalize(() => {this.isloading = false; }))
      .subscribe((data)=>{
        this.downloadItems = data.map( rec =>{
        return {
          ...rec,
          dateOnly: moment(rec.timeCreated).startOf('day').format('MMM D, YYYY'),
        }
      }).sort((a, b) => moment(b.timeCreated).diff(moment(a.timeCreated)));
      },
      (res) =>{
        this.errorService.showError(res);
      });

    
  }
  toolbarClick(){

  }
  downloadFile(downloadData: DownloadItems ) {
     const fileUrl = downloadData.fileUrl;
     const fileName = downloadData.fileName || fileUrl.split('/').pop();
      this.downloadService.downloadFileBlob(downloadData).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((blob) =>{
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(blobUrl);
        this.toastrService.success("File successfully downloaded!",fileName + " saved!")
      },
      (err) =>{
        this.errorService.showError("File Downloading Failed!!!");
      }
  )
  }
  clearFilters(){
     this.grid.clearFiltering();
     this.filterCount = 0;
  }

  onActionComplete(args: any) {
    if (args.requestType === 'filtering') {
      this.updateFilterCount();
    }
  }

  onGridDataBound() {
    this.updateFilterCount();
  }

  private updateFilterCount() {
    const cols = (this.grid && this.grid.filterSettings && this.grid.filterSettings.columns) ? this.grid.filterSettings.columns : [];
    const uniqueFields = cols.map(c => c.field as string).filter((f: string, i: number, a: string[]) => a.indexOf(f) === i);
    this.filterCount = uniqueFields.length;
  }
  
}
  
